import React from "react";
import { Create, Edit } from "admin-on-rest";
import IconTitle from "../components/icon_title";
import PaymentCRUDForm from "./PaymentCRUDForm";

export const PaymentModeCreate = props => (
  <Create
    {...props}
    title={
      <IconTitle icon="payments" title={"resources.paymentmode.titleNew"} />
    }
  >
    {permissions => <PaymentCRUDForm {...props} permissions={permissions} />}
  </Create>
);

export const PaymentModeEdit = props => (
  <Edit
    {...props}
    title={
      <IconTitle icon="payments" title={"resources.paymentmode.titleEdit"} />
    }
  >
    {permissions => <PaymentCRUDForm {...props} permissions={permissions} />}
  </Edit>
);



// WEBPACK FOOTER //
// ./src/paymentmode/Detail.js